export default __webpack_public_path__ + "static/media/Project-3-PortfolioPage-MainImg.3816fb8e.png";